<template>
  <div
    style="display: flex; justify-content: center; align-items: center;"
  >
    <div
      style="max-width: 560px; background-color: #fff; margin: 100px auto; border-radius: 10px; flex: 1;"
    >
      <div style="max-width: 400px; margin: 0 auto;">
        <a-result status="500" title="500" subTitle="Server zaznamenal interní chybu a nemohl dokončit Váš požadavek.">
          <template v-slot:extra>
            <a-button @click="handleBack" type="primary"><a-icon type="left"/>Vrátit se zpět</a-button>
            <a-button @click="goDashboard"><a-icon type="home"/>Přejít na nástěnku</a-button>
          </template>
        </a-result>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    goDashboard() {
      this.$router.push('/dashboard')
    },
  },
}
</script>
